module.exports = __webpack_public_path__ + "1586a3f68c94c21d03ff396eae68ad42.png";